var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCarouselChevron = function SvgCarouselChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.828 14 10.586 10.586a2 2 0 0 1-2.828 2.828l-12-12a2 2 0 0 1 0-2.828l12-12a2 2 0 1 1 2.828 2.828L4.828 14z",
    fill: "#C2C2C2"
  })));
};

export { SvgCarouselChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQuODI4IDE0bDEwLjU4NiAxMC41ODZhMiAyIDAgMDEtMi44MjggMi44MjhsLTEyLTEyYTIgMiAwIDAxMC0yLjgyOGwxMi0xMmEyIDIgMCAxMTIuODI4IDIuODI4TDQuODI4IDE0eiIgZmlsbD0iI0MyQzJDMiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+";